var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPartially(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 47.5 47.5",
    xmlns: "http://www.w3.org/2000/svg",
    id: "p",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 38h38V0H0v38Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.25 0 0 -1.25 0 47.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D4BE31",
    d: "M37 5a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v28a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.428 19.41h3.162c1.954 0 3.194 1.426 3.194 3.287 0 1.86-1.24 3.286-3.194 3.286h-3.162V19.41Zm-4.651 8.248c0 1.457.868 2.418 2.419 2.418h5.487c4.559 0 7.938-2.977 7.938-7.41 0-4.527-3.504-7.349-7.752-7.349h-3.441v-5.085c0-1.551-.992-2.418-2.326-2.418-1.333 0-2.325.867-2.325 2.418v17.426z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPartially);
export default __webpack_public_path__ + "static/media/ico-partially.966e2edcd3c15f6091c2fcd4ab39912c.svg";
export { ForwardRef as ReactComponent };